import styles from "./ModeSelector.module.css";
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const ModeSelector = ({ onSelect, onClose, embedded = false }) => {
  return (
    <div className={`${styles.wrapper} ${embedded ? styles.embeddedModeSelector : null}`}>
      {!embedded && (
        <div className={styles.header}>
          <div>
            <h4 className={styles.brand}>nxNearby's AI Assistant</h4>
            <p className={styles.subBrand}>Your personal AI helper</p>
          </div>

          <button className={styles.closeBtn} onClick={onClose}>
            <CloseRoundedIcon />
          </button>
        </div>
      )}
      
      <div className={styles.content}>
        <h2 className={styles.title}>How can I help you today?</h2>
        <p className={styles.subtitle}>Choose what you're looking for</p>

        <div className={styles.cardStack}>
          <button
            className={styles.card}
            onClick={() => onSelect("courses")}
          >
            <div className={`${styles.iconBox} ${styles.course}`}>
              <SchoolOutlinedIcon />
            </div>

            <div className={styles.cardText}>
              <h4>Find Courses</h4>
              <p>Discover learning opportunities tailored to your goals</p>
            </div>
          </button>

          <button
            className={styles.card}
            onClick={() => onSelect("jobs")}
          >
            <div className={`${styles.iconBox} ${styles.jobs}`}>
              <BusinessCenterOutlinedIcon />
            </div>

            <div className={styles.cardText}>
              <h4>Explore Jobs</h4>
              <p>Find the perfect job match for your skills</p>
            </div>
          </button>

          <button
            className={styles.card}
            onClick={() => onSelect("profile")}
          >
            <div className={`${styles.iconBox} ${styles.profile}`}>
              <PersonOutlineOutlinedIcon />
            </div>

            <div className={styles.cardText}>
              <h4>Profile</h4>
              <p>Search for People</p>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModeSelector;
